// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchTabs_container__3kj3A"};